import _ from 'lodash';

export const computeImageSize = (breakpoint, cgiSize, imageSize) => {
  if (imageSize) {
    return cgiSize[imageSize];
  }

  switch (breakpoint) {
    case 'medium':
      return cgiSize['large'];
    case 'small':
      return cgiSize['medium'];
    case 'xsmall':
      return cgiSize['small'];
    case 'xlarge':
      return cgiSize['xLarge'];
    default:
      return (breakpoint && cgiSize[breakpoint]) || null;
  }
};

export const computeDefaultAngle = (
  imageAngle,
  exteriorAngles,
  interiorAngles,
  wheelAngles,
  isInterior
) => {
  if (isInterior) {
    return interiorAngles?.find((angle) => angle.defaultAngle === true).value;
  }
  if (imageAngle === 'default') {
    return exteriorAngles?.find((angle) => angle.defaultAngle === true).value;
  }
  if (imageAngle === 'profile') {
    return exteriorAngles?.find((angle) => angle.profileView === true).value;
  }
  if (imageAngle === 'wheel') {
    return wheelAngles?.find((angle) => angle.profileView === true).value;
  }

  return exteriorAngles?.find((angle) => angle.defaultAngle === true).value;
};

export const addBackground = (url, hexColor) => {
  return `${url}&background=${hexColor}`;
};

export const addTransparency = (url) => {
  return `${url}&transparentBackgroundPng=true`;
};

const getTokens = (id) => {
  const tokens = _.split(id, /_|-/);
  const uniqueTokens = _.uniq(tokens);
  return _.compact(uniqueTokens);
};

const buildMmcPegData = (style) => {
  const { cgiCode, alternateId } = style;

  if (_.endsWith(cgiCode, '-DRW')) {
    const tokens = cgiCode.replace('-DRW', '').split('__');
    return {
      mmc: `${tokens[0]}D`,
      peg: `${tokens[0]}D__${tokens[1]}`,
    };
  }

  const tokens = getTokens(alternateId || cgiCode);
  return {
    mmc: tokens[0],
    peg: `${tokens[0]}__${tokens[1]}`,
  };
};

export const getCGISelectedStateUrl = ({
  year,
  cgiUrl,
  selections,
  style,
  angle,
  size,
  isInterior,
}) => {
  const buildUrl = _.template(cgiUrl);
  const { rpos, exteriorColor, interiorColor } = selections;
  const { mmc, peg } = buildMmcPegData(style.vehicleInfo);

  const context = {
    renderStandards: true,
    removeCat: '',
    colorRPO: `${isInterior ? interiorColor : exteriorColor}_`,
    imageSize: size,
    optionRPOs: rpos.join('_'),
    interior: isInterior ? 'interior' : '',
    mmc,
    peg,
    degree: angle,
    year,
  };
  return buildUrl(context);
};

export const getVisualizerUrl = (
  visualizerUrlTemplate,
  style,
  bodystyle,
  year,
  brand,
  selections,
  background,
  angle
) => {
  const buildUrl = _.template(visualizerUrlTemplate);
  // TODO: If we need to take alternate id into account, do opposite of what we do with DRW id.
  const { code: peg } = style.vehicleInfo;

  const rpos = selections && selections.rpos.join(',');

  // Carline codes used for requests for Corvette pixelstream should include the 'edition'
  // (ie Corvette-z06 and Corvette-stingray) in the carlineCode. This is due to the availability
  // of multiple editions within a single model year.
  //
  // We'll need to account for z06 also, once the 2023 corvette is included
  if (bodystyle === 'corvette') {
    bodystyle = 'corvette-stingray';
  }

  const context = {
    peg,
    year,
    brand,
    bodystyle,
    rpos,
    isExterior: true,
    backgroundColor: background,
    angle,
  };

  return buildUrl(context);
};
